import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { cx } from "shared/utils/classnames";
import type { ReplyTarget } from "../types";
import { LinkBackwardSolidRounded } from "@hugeicons-pro/core-solid-rounded";

interface ReplyBannerProps {
  target: ReplyTarget;
  onCancel: () => void;
  /** Pop-up: a tighter card that fits the 400px column above the input card. */
  compact?: boolean;
}

export const ReplyBanner = ({
  target,
  onCancel,
  compact = false
}: ReplyBannerProps) => (
  <div
    className={cx(
      "flex items-start gap-2.5 border-l-[3px] border-primary-500 bg-primary-50",
      compact ? "mb-2 rounded-lg px-3 py-2" : "p-4"
    )}
  >
    <HugeiconsIcon
      icon={LinkBackwardSolidRounded}
      size={compact ? 16 : 20}
      className="text-primary-500 mt-0.5 flex-shrink-0"
    />

    <div className="flex-1 min-w-0 space-y-1">
      <div
        className={cx(
          "flex min-w-0 items-center gap-2.5 font-bold text-primary-500",
          compact ? "text-xs" : "text-sm"
        )}
      >
        <span className="shrink-0">From:</span>
        <span className="truncate">{target.fromName}</span>
        <span className="size-1 shrink-0 rounded-full bg-primary-500" />
        <span className="truncate">{target.fromAddress}</span>
      </div>
      <p
        className={cx(
          "font-medium text-primary-500 line-clamp-1",
          compact ? "text-xs" : "text-sm"
        )}
      >
        {target.preview}
      </p>
    </div>

    <IconButton
      HugeIcon={Cancel01Icon}
      variant={IconButtonVariant.TEXT}
      size={compact ? IconButtonSize.XS : IconButtonSize.SM}
      onClick={onCancel}
      aria-label="Cancel reply"
      className="flex-shrink-0"
    />
  </div>
);
